var pf_user_id = 1104;
waitForVariable();

function waitForVariable(){
    if(typeof shopify_order_obj !== "undefined"){
		
      
		calculateOrderProgress();
        fillOutOrderDetails();
      
      
      $( "#siteContainer" ).css( "visibility", "visible" );
    } else {
        setTimeout(waitForVariable, 250);
  
    }
}

function calculateOrderProgress()
{
	// Determine the order status using the order tags
	// Status 1 = no tags, Order received; 2 = no tag + 24 hours since order, Work in Progress; 3 = proof_sent Tag, Preview ready; 4 = proof_accepted, Preview accepted, 5 = Order fulfilled, Order shipped
	
	var OrderStatus = 1;
	
	if(shopify_order_obj["tags"].includes("proof_sent"))
	{
		OrderStatus = 3;	
      $( "#previewNotes" ).css( "visibility", "visible" );
       $( "#previewNotes" ).css( "height", "100%" );
	}
    else if(shopify_order_obj["tags"].includes("proof_rejected") && shopify_order_obj["tags"].includes("paid_for_changes"))
	{
		OrderStatus = 3.6;
			
	}
	else if(shopify_order_obj["tags"].includes("proof_rejected"))
	{
		OrderStatus = 3.5;
			
	}
	else if(shopify_order_obj["tags"].includes("proof_accepted"))
	{
		OrderStatus = 4;
			
	}
	else
	{

	}		
		
	
	//Check if order is fulfilled
	
	if(shopify_order_obj["fulfillment_status"] != null)
	{
		OrderStatus = 5;
		
	}

	//Calculate if order is 24 hours old, if yes status = 2
	if(OrderStatus == 1)
	{
		
		
		var currentDate = new Date().getTime();
		var order_dateplus = new Date(shopify_order_obj["created_at"]).getTime() + (24 * 60 * 60 * 1000);
		
		if (currentDate > order_dateplus) {
			// The order is older than 24 hours
			
			OrderStatus = 2;
		}
		else {
			
		}

	}

	//DrawProgressBar
	drawProgressBar(OrderStatus);
    hideProoferComponents(OrderStatus);
  createPlaceholderImages(OrderStatus);

}

function drawProgressBar(order_status)
{
	var progressBarString ="<ul class='progress-indicator'>";
	
	if(order_status == 1)
	{
		progressBarString += "<li class='active'> <span class='bubble'></span>Bestellung Eingegangen</li>";
		progressBarString += "<li><span class='bubble'></span>Zeichnung in Arbeit</li>";
		progressBarString += "<li><span class='bubble'></span>Vorschau bereit</li>";
		progressBarString += "<li><span class='bubble'></span>Zeichnung bestätigt</li>";
		progressBarString += "<li><span class='bubble'></span>Bestellung versendet</li>";

	}	
	else if(order_status == 2)
	{
		progressBarString += "<li class='completed'> <span class='bubble'></span>Bestellung Eingegangen</li>";
		progressBarString += "<li class='active'><span class='bubble'></span>Zeichnung in Arbeit</li>";
		progressBarString += "<li><span class='bubble'></span>Vorschau bereit</li>";
		progressBarString += "<li><span class='bubble'></span>Zeichnung bestätigt</li>";
		progressBarString += "<li><span class='bubble'></span>Bestellung versendet</li>";

	}	
	else if(order_status == 3)
	{
		progressBarString += "<li class='completed'> <span class='bubble'></span>Bestellung Eingegangen</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Zeichnung in Arbeit</li>";
		progressBarString += "<li class='active'><span class='bubble'></span>Vorschau bereit</li>";
		progressBarString += "<li><span class='bubble'></span>Zeichnung bestätigt</li>";
		progressBarString += "<li><span class='bubble'></span>Bestellung versendet</li>";

	}	
	else if(order_status == 3.5 || order_status == 3.6)
	{
		progressBarString += "<li class='completed'> <span class='bubble'></span>Bestellung Eingegangen</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Zeichnung in Arbeit</li>";
		progressBarString += "<li class='active'><span class='bubble'></span>Änderungen angefragt</li>";
		progressBarString += "<li><span class='bubble'></span>Zeichnung bestätigt</li>";
		progressBarString += "<li><span class='bubble'></span>Bestellung versendet</li>";

	}	
	else if(order_status == 4)
	{
		progressBarString += "<li class='completed'> <span class='bubble'></span>Bestellung Eingegangen</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Zeichnung in Arbeit</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Vorschau bereit</li>";
		progressBarString += "<li class='active'><span class='bubble'></span>Zeichnung bestätigt</li>";
		progressBarString += "<li><span class='bubble'></span>Bestellung versendet</li>";

	}	
	else if(order_status == 5)
	{
		progressBarString += "<li class='completed'> <span class='bubble'></span>Bestellung Eingegangen</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Zeichnung in Arbeit</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Vorschau bereit</li>";
		progressBarString += "<li class='completed'><span class='bubble'></span>Zeichnung bestätigt</li>";
		progressBarString += "<li class='active'><span class='bubble'></span>Bestellung versendet</li>";
		
	}
	else
	{
		//No Order Status
	}
		
	progressBarString += "</ul>";	
  
    
  
	document.getElementById("progressContainer").innerHTML = progressBarString;
	
}

function hideProoferComponents(order_status)
{
 
  //Hide Proofer Elements if order_status is 1 or 2
  
  if(order_status == 1 || order_status == 2)
  {
    
    $( "#pf_content_div" ).css( "visibility", "hidden" );
    $( "#pf_content_div" ).css( "height", "0px" );
    
  }
  
  
}

function createPlaceholderImages(order_status)
{
  
  
  if(order_status == 1)
  {
   	document.getElementById("pictureContainer").innerHTML = "<img id='descImage' src='https://cdn.shopify.com/s/files/1/0588/8147/4739/files/single2.png?v=1641625749'></img><br><br><div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div><span id='status_desc'>Wir haben deine Bestellung erfolgreich erhalten! Sie wird bald einem unserer talentierten Künstler zugewiesen.</span>";
  }
  else if(order_status == 2)
  {
    document.getElementById("pictureContainer").innerHTML = "<img id='descImage' src='https://cdn.shopify.com/s/files/1/0588/8147/4739/files/couple_681e526f-08c2-4bff-bfbf-f34a83dbf443.png?v=1641625555'></img><br><br><div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div><span id='status_desc'>Tolle Neuigkeiten! Deine Zeichnung wurde einem Künstler zugewiesen und befindet sich nun in Arbeit. Dieser Prozess dauert aktuell ca. fünf Werktage.</span>";

  }
  else if(order_status == 3)
  {
    document.getElementById("pictureContainer").innerHTML = "<div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div>";

  }
  else if(order_status == 3.5)
  {
    document.getElementById("pictureContainer").innerHTML = "<div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div><span id='status_desc'>Wir haben deine Änderungsanfrage erhalten! Sollten die gewünschten Änderungen kostenpflichtig sein, werden wir dich per Email kontaktieren. Andernfalls erhältst du innerhalb der nächsten Werktage eine neue Vorschau inlusive der umgesetzten Änderungen.</span>";

  }
  else if(order_status == 3.6)
  {
    document.getElementById("pictureContainer").innerHTML = "<div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div><span id='status_desc'>Wir haben deine kostenpflichtigen Änderungswünsche erhalten! Du erhältst innerhalb der nächsten Werktage eine neue Vorschau inlusive der umgesetzten Änderungen.</span>";

  }
  else if(order_status == 4)
  {
    document.getElementById("pictureContainer").innerHTML = "<div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div><span id='status_desc'>Vielen Dank für die Freigabe deiner Zeichnung! Falls eine Druckversion bestellt wurde, wurde Sie erfolgreich an unsere Druckabteilung weitergeleitet. Im Regelfall wird diese innerhalb der nächsten drei Werktage versendet. Du erhältst eine separate Versandbestätigung, sobald dies der Fall ist.</span>";

  }
  else if(order_status == 5)
  {
    document.getElementById("pictureContainer").innerHTML = "<img id='descImage' src='https://cdn.shopify.com/s/files/1/0588/8147/4739/files/family_28612116-b546-4d00-9323-6e7e37bdaf10.png?v=1641624010'></img><br><br><div id='greetContainer' style='margin-top: -20px;font-family:&quot;GROTESKBOLD&quot;;font-weight: 700;font-size: 20px;margin: 10px;'><span>Hey "+shopify_order_obj["customer"]["first_name"]+"!</span></div><span id='status_desc'>Darauf stoßen wir an! Deine Bestellung wurde erfolgreich gedruckt und an dich versendet!</span><br><div id='shipped' style='text-align: center; width: 100%; margin-top: 20px;'>Deine Sendungsverfolgung kannst du hier einsehen:  <a href='"+ shopify_order_obj["fulfillments"][0]["tracking_url"] + "'>Hier klicken</a></div>";
  }
  else
  {
    //Hide Placeholder Images
     $( "#statusDesc" ).css( "visibility", "hidden" );
    $( "#statusDesc" ).css( "height", "0px" );
    
  }
  
}
                                


function fillOutOrderDetails(){
  
  var ordernumber = shopify_order_obj['number'] + 1000;
	
	document.getElementById("order_id").innerHTML = ordernumber;
	document.getElementById("email").innerHTML = shopify_order_obj['email'];

	var details = "";
	
	for (let x=0; x<shopify_order_obj["line_items"].length; x++) {
		for (let i=0; i<shopify_order_obj["line_items"][x]["properties"].length; i++) {

			if(shopify_order_obj["line_items"][x]["properties"][i]["name"] == "_boldVariantNames")
			{
				
			}
            else if (shopify_order_obj["line_items"][x]["properties"][i]["name"].includes("Hochgeladenes Bild"))
			{

			}
            else if (shopify_order_obj["line_items"][x]["properties"][i]["name"].includes("Anmerkung") || shopify_order_obj["line_items"][x]["properties"][i]["name"].includes("Nachricht"))
			{

			}
			else if (shopify_order_obj["line_items"][x]["properties"][i]["name"] == "_boldVariantIds")
			{

			}
			else if (shopify_order_obj["line_items"][x]["properties"][i]["name"] == "_boldProductIds")
			{

			}
			else if (shopify_order_obj["line_items"][x]["properties"][i]["name"] == "_boldVariantPrices")
			{

			}
			else if (shopify_order_obj["line_items"][x]["properties"][i]["name"] == "_boldBuilderId")
			{

			}
			else
			{
				
				var cutName = shopify_order_obj["line_items"][x]["properties"][i]["name"].substring(shopify_order_obj["line_items"][x]["properties"][i]["name"].indexOf(":") +1);
				
				details += "<tr>";
                details += "<td style='font-weight: 700;'>" + cutName + "</td>";
				details += "<td>" + shopify_order_obj["line_items"][x]["properties"][i]["value"] + "</td>";
				details += "</tr>";
				
			}
				
		 
		}
	}

	document.getElementById("detail_table").innerHTML = details;

}